import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useContext, useState } from "react";
import { Grid, debounce } from "@mui/material";
import BaseButton from "./BaseButton";
import { ArrowForwardIos } from "@mui/icons-material";
import { MainContext } from "../context/MainContextProvider";
import { RopCancelRegisterModal } from "./RopCancelRegisterModal";
import DangerBaseButton from "./DangerBaseButton";

export function RopFormFooter(props: {
  selectedStep: number;
  handleNext: () => void;
  handleBack: () => void;
  handleSave: () => Promise<void>;
  modalText: string;
  onCancel: () => void;
  steps: number;
}) {
  const { theme } = useContext(MainContext);
  const { handleNext, handleBack, handleSave, onCancel, modalText } = props;
  const onlyOneStep = props.steps === 1;
  const primary = theme.muiTheme.palette.primary.main;
  const { isMobile } = useContext(MainContext);
  const [cancelModalOpen, setCancelModalOpen] = useState(false);
  const [saveIsLoading, setSaveIsLoading] = useState(false);
  // const showBackButton = onlyOneStep ? false : props.selectedStep > 0;
  const showBackButton = props.selectedStep > 0;

  // const showNextButton = onlyOneStep ? false : props.selectedStep < props.steps;
  const showNextButton = props.selectedStep < props.steps - 0;

  const showCancelButton =
    (props.selectedStep === 0 && !onlyOneStep) || props.selectedStep > 0;
  // const showCancelButton = true;

  const showSaveButton = props.selectedStep === props.steps - 0;

  const handleCancel = () => setCancelModalOpen(true);
  const save = async () => {
    setSaveIsLoading(true);
    try {
      await handleSave();
    } catch (error) {
      throw "Ocorreu um erro ao salvar";
    } finally {
      setSaveIsLoading(false);
    }
  };

  const debouncedClickHandler = debounce(save, 1500);

  return (
    <>
      {/* Grid para dispositivos móveis */}
      {isMobile && (
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: "100%",
            paddingRight: { xs: "10px", sm: "20px" },
            paddingLeft: { xs: "10px", sm: "20px" },
            paddingTop: "20px",
            paddingBottom: "20px",
            marginBottom: "10px",
          }}
        >
          {/* Botão de Cancelar à esquerda na primeira tela */}
          {showCancelButton && props.selectedStep === 0 && (
            <DangerBaseButton
              onClick={handleCancel}
              title="Cancelar"
              sx={{ height: "38px", width: "145px" }}
            />
          )}

          {/* Botão de Voltar à esquerda nas telas subsequentes */}
          {showBackButton && props.selectedStep > 0 && (
            <BaseButton
              title="Voltar"
              startIcon={<ArrowBackIosIcon />}
              onClick={handleBack}
              sx={{
                width: "48%",
                height: "38px",
              }}
            />
          )}

          {/* Botão de Avançar ou Salvar à direita nas telas não finais */}
          {showNextButton && (
            <BaseButton
              title={showSaveButton ? "Salvar" : "Avançar"}
              onClick={showSaveButton ? save : handleNext}
              sx={{
                color: showSaveButton ? primary : "primary",
                display: "flex",
                width: "48%",
                height: "38px",
              }}
              endIcon={showSaveButton ? undefined : <ArrowForwardIos />}
            />
          )}

          {/* Botão de Salvar à direita na última tela */}
          {showSaveButton && (
            <BaseButton
              title="Salvar"
              onClick={debouncedClickHandler}
              sx={{
                backGroundColor: primary,
                borderColor: primary,
                "& .MuiTypography-root": {
                  color: primary,
                },
                "&:hover": {
                  borderColor: primary,
                  backgroundColor: primary,
                  color: primary,
                  "& .MuiTypography-root": {
                    color: "#FFFFFF",
                  },
                },
                width: "48%",
                height: "38px",
              }}
            />
          )}

          {/* Botão de Cancelar à direita nas demais telas */}
          {showCancelButton && props.selectedStep > 0 && (
            <DangerBaseButton
              onClick={handleCancel}
              title="Cancelar"
              sx={{ height: "38px", width: "145px", marginTop: "15px" }}
            />
          )}
        </Grid>
      )}

      {/* Restante do código para desktop ou outros dispositivos */}
      {!isMobile && (
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: "100%",
            paddingRight: { xs: "10px", sm: "20px" },
            paddingLeft: { xs: "10px", sm: "20px" },
            paddingTop: "20px",
            paddingBottom: "20px",
          }}
        >
          {/* Botão de Cancelar */}
          {showCancelButton && (
            <DangerBaseButton
              onClick={handleCancel}
              title="Cancelar"
              sx={{ height: "38px", width: "145px" }}
              // sx={{
              //   width: "80px",
              //   height: "38px",
              // }}
            />
          )}

          <Grid
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {/* Botão de Voltar */}
            {showBackButton && (
              <BaseButton
                title="Voltar"
                startIcon={<ArrowBackIosIcon />}
                onClick={handleBack}
                sx={{
                  width: "100px",
                  marginRight: "14px",
                  height: "38px",
                }}
              />
            )}

            {/* Botão de Avançar ou Salvar */}
            {showNextButton && (
              <BaseButton
                title={showSaveButton ? "Salvar" : "Avançar"}
                onClick={showSaveButton ? save : handleNext}
                sx={{
                  color: showSaveButton ? "primary" : undefined,
                  display: "flex",
                  width: "100px",
                  height: "38px",
                }}
                endIcon={showSaveButton ? undefined : <ArrowForwardIos />}
              />
            )}

            {/* Botão de Salvar (apenas se não houver botão de Avançar) */}
            {showSaveButton && !showNextButton && (
              <BaseButton
                loading={saveIsLoading}
                onClick={save}
                title="Salvar"
                sx={{
                  backGroundColor: primary,
                  borderColor: primary,
                  "& .MuiTypography-root": {
                    color: primary,
                  },
                  "&:hover": {
                    borderColor: primary,
                    backgroundColor: primary,
                    color: primary,
                    "& .MuiTypography-root": {
                      color: "#FFFFFF",
                    },
                  },
                  width: "100px",
                  height: "38px",
                }}
              />
            )}
          </Grid>
        </Grid>
      )}

      {/* Restante do código, como o modal */}
      <RopCancelRegisterModal
        open={cancelModalOpen}
        setOpen={setCancelModalOpen}
        modalText={modalText}
        onCancel={onCancel}
      />
    </>
  );
}
